import { useLocaleContext } from "@/modules/i18n/context"
import { cn } from "@/utils/cn"
import {
  MAX_CV_SIZE_BYTES,
  isAllowedCvExtension,
} from "@/features/funnel/cv-upload-constraints"
import { useDropzone } from "react-dropzone"

interface DropzoneProps {
  className?: string
  file: File | null
  onFileChange: (file: File | null) => void
}

export function Dropzone({ className, file, onFileChange }: DropzoneProps) {
  const $ = useLocaleContext().$.dropzone
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: MAX_CV_SIZE_BYTES,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0]
        if (isAllowedCvExtension(file.name)) {
          onFileChange(file)
        } else {
          onFileChange(null)
        }
      }
    },
    accept: {
      "application/pdf": [".pdf"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
      "application/vnd.oasis.opendocument.text": [".odt"],
    },
  })
  return (
    <div
      {...getRootProps()}
      className={cn(
        "relative mt-4 rounded-md border-2 border-dashed border-viola-150 px-4 py-9 text-center font-family-gthaptik font-light text-neutral-dark opacity-50",
        file && "border-viola-500",
        className
      )}
    >
      <input {...getInputProps()} />
      {file ? (
        <div className="break-all">
          {$.fileUploaded} <br />
          <br />
          {file.name}
        </div>
      ) : (
        <div className="mx-auto max-w-xs">{$.uploadFile}</div>
      )}
    </div>
  )
}
